export const LAST_UPDATED_DATE = '22-09-2025'
